import React from "react";
import {
  Grid as ChakraGrid,
  GridProps as ChakraGridProps,
  forwardRef,
  useStyleConfig,
} from "@chakra-ui/react";

export type GridProps = ChakraGridProps;

export const LayoutGrid = forwardRef<GridProps, "div">((props, ref) => {
  const styles = useStyleConfig("LayoutGrid");

  return <ChakraGrid __css={styles} {...props} ref={ref} />;
});
